import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root'
})
export class AppointmentService {

	constructor(private api: ApiService) { }

	create(data: any) {
		data.merchant_id = this.api.MERCHANT_ID;
		return this.api.post("appointment/create", data, true);
	}

	landing(data: any) {
		data.merchant_id = this.api.MERCHANT_ID;

		data.title = 'Dual Days Alcon - Marcação de Avaliação';
		data.destination = 'sofia.roque@opticaslince.com,loja.matosinhos1@opticaslince.com';

		return this.api.post("appointment/landing", data, true);
	}
}
